$(document).ready(function () {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      const video = $('video', mutation.target)[0];
      if (!mutation.target.hasAttribute('open')) {
        video.pause();
        video.currentTime = 0;
      } else {
        video.play();
      }
    }
  });

  const observeElements = $('.bl-popover:has(video)');

  for (let el of observeElements) {
    observer.observe(el, {
      attributes: true,
      attributeFilter: ['open']
    });
  }

  const subscriptionObserver = new MutationObserver((mutationsList) => {
    updateSellingPlanPrice();
  });

  function updateSellingPlanPrice(first = false) {
    const priceEl = $(`.product .variant-picker .bl-variant_price`);
    console.log($(`.appstle_subscription_wrapper_option input:checked`).val());
    if ($(`.appstle_subscription_wrapper_option input:checked`).val()) {
      $(priceEl).each((i, el) => {
        $(`span`, el).html($(el).attr('sub-price'));
        if ($(el).attr('sub-discount')) {
          $(el).parent().parent().find(`.badge--on-sale`).html(`Save ${$(el).attr('sub-discount')}`);
          $(el).parent().parent().find(`.badge--on-sale`).removeAttr('hidden');
        } else {
          $(el).parent().parent().find(`.badge--on-sale`).attr('hidden', '');
        }
      });
    } else {
      $(priceEl).each((i, el) => {
        $(`span`, el).html($(el).attr('price'));
        if ($(el).attr('discount')) {
          $(el).parent().parent().find(`.badge--on-sale`).html(`Save ${$(el).attr('discount')}`);
          $(el).parent().parent().find(`.badge--on-sale`).removeAttr('hidden');
        } else {
          $(el).parent().parent().find(`.badge--on-sale`).attr('hidden', '');
        }
      });
    }
  }

  function waitForElement(elName, callback) {
    const interval = setInterval(() => {
      if ($(elName).length > 0) {
        clearInterval(interval);
        callback($(elName));
      }
    }, 50);
  }

  if (window.location.pathname.startsWith('/products')) {
    if ($(`.product:not([subscription-product])`).length > 0) {
      return;
    }

    const target = `.appstle_subscription_wrapper_option.appstle-active-option`;
    waitForElement(target, (el) => {
      $(el).each((i, e) => {
        subscriptionObserver.observe(e, {
          attributes: true,
          attributeFilter: ['class']
        });
      });

      updateSellingPlanPrice();
    });

    $(document).on('variant:change', function(e) {
      const target = `.appstle_subscription_wrapper_option.appstle-active-option`;

      waitForElement(target, (el) => {
        $(el).each((i, e) => {
          subscriptionObserver.observe(e, {
            attributes: true,
            attributeFilter: ['class']
          });
        });
      });
    });
  }
});